export default __webpack_public_path__ + "static/media/oops.2bfad938.jpg";